<template>
  <VueLoadingOverlay :active.sync="active" :is-full-page="true">
    <template #default>
      <i class="el-icon-loading" style="font-size: 50px; color: #009995"></i>
      <div
        style="font-size: 18px; color: #009995; margin-top: 10px"
        v-if="$slots.desc"
      >
        <slot name="desc"></slot>
      </div>
    </template>
  </VueLoadingOverlay>
</template>

<script>
import VueLoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "LoadingOverlay",
  components: {
    VueLoadingOverlay,
  },
  props: ["active"],
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.vld-overlay ::v-deep .vld-icon {
  text-align: center;
}
</style>
